<template>
  <div>
    <div class="statistics-item">
      <NumberData></NumberData>
    </div>
    <div class="statistics-item">
      <TrendChart1></TrendChart1>
    </div>
    <div class="statistics-item">
      <TrendChart2></TrendChart2>
    </div>
    <div class="statistics-item">
      <BonusReport></BonusReport>
    </div>
  </div>
</template>

<script>
import BonusReport from './components/BonusReport'
import NumberData from './components/NumberData'
import TrendChart1 from './components/TrendChart1'
import TrendChart2 from './components/TrendChart2'

export default {
  name: 'Statistics',
  components: { BonusReport, NumberData, TrendChart1, TrendChart2 },
  created() {
    this.$store.dispatch('link/GetAllActivities')
  },
}
</script>

<style lang="scss" scoped>
.statistics-item {
  margin-top: 20px;
  // width: 1000px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #eceef0;
  text-align: left;
}
</style>
